import ChatBubbleContext from '@components/DevRev/SupportBubbleContext';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { Box, IconButton, List, ListItem, Popover } from '@mui/material';
import { HELP_LINKS } from '@utils/docs';
import HelpItem from 'pages/Help/HelpItem';
import React, { FC } from 'react';
import { IChatBubbleContext } from 'types/devRev';

const HelpPopover: FC = () => {
	const { open } = React.useContext<IChatBubbleContext>(ChatBubbleContext);
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const isMenuOpen = Boolean(anchorEl);
	const id = isMenuOpen ? 'help-popover' : undefined;

	return (
		<Box>
			<IconButton
				aria-describedby={id}
				aria-label={intl.tr('button.help')}
				onClick={handleClick}
				color="inherit"
				data-testid="help-popover-button"
			>
				<HelpOutlineIcon
					fontSize="small"
					sx={{
						color: 'text.secondary'
					}}
				/>
			</IconButton>
			<Popover
				id={id}
				open={isMenuOpen}
				anchorEl={anchorEl}
				onClose={handleClose}
				onClick={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
			>
				<List
					sx={{
						width: 350
					}}
					data-testid="help-popover-list"
				>
					<ListItem>
						<HelpItem
							itemKey="documentation"
							url={HELP_LINKS.documentation}
							icon={<SchoolOutlinedIcon />}
							size="small"
						/>
					</ListItem>
					<ListItem>
						<HelpItem
							itemKey="community"
							url={HELP_LINKS.community}
							icon={<LocalLibraryOutlinedIcon />}
							size="small"
						/>
					</ListItem>
					<ListItem>
						<HelpItem
							itemKey="getHelp"
							onClick={open}
							icon={<LiveHelpOutlinedIcon />}
							size="small"
						/>
					</ListItem>
				</List>
			</Popover>
		</Box>
	);
};

export default HelpPopover;
